/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../jobs');
const R = require('ramda');

module.exports = R.mergeDeepRight(jobiqoJobsConfig, {
  public: {
    SHOW_ONLY_FEATURED_JOBS: true,
    FEATURED_JOBS_HIDE_BACKFILL_IMPORTER_JOBS: true,
    GEO_INFO: {
      fixtures: [],
    }
  }
});
